import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery, getLocalizationHeader } from '../Utils/queryUtils';
import { IJsonResponse } from 'Types/Interface/IApiRequestResponseBody';

export const chatbaseApi = createApi({
	reducerPath: 'chatbaseApi',
	baseQuery,
	endpoints: (builder) => ({
		sign: builder.mutation<IJsonResponse<string>, { surveyId: string; locale: string }>({
			query: ({ surveyId, locale }) => ({
				url: 'chatbase/sign',
				method: 'POST',
				params: { surveyId },
				headers: getLocalizationHeader(locale),
			}),
		}),
		tryCompleteSurvey: builder.mutation<IJsonResponse<boolean>, { qrCodeId: string }>({
			query: ({ qrCodeId }) => ({
				url: 'chatbase/try-complete-survey',
				method: 'POST',
				params: { qrCodeId },
			}),
		}),
	}),
});

export const {
	useSignMutation,
	useTryCompleteSurveyMutation,
} = chatbaseApi;
